// Initialize theme by setting CSS variables and favicon
// This should be called early in the app lifecycle

import theme from './themes';

/**
 * Update favicon links in the document head
 */
const updateFavicon = () => {
  if (typeof document === 'undefined') return;

  // Remove existing favicon links
  const existingLinks = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
  existingLinks.forEach(link => link.remove());

  // Get PUBLIC_URL (handles both development and production)
  const publicUrl = process.env.PUBLIC_URL || '';
  const basePath = publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
  
  // Add new favicon links
  const faviconLink = document.createElement('link');
  faviconLink.rel = 'icon';
  faviconLink.type = 'image/svg+xml';
  faviconLink.href = `${basePath}${theme.favicon}`;
  document.head.appendChild(faviconLink);

  // Add ICO fallback for older browsers
  const faviconIcoLink = document.createElement('link');
  faviconIcoLink.rel = 'alternate icon';
  faviconIcoLink.type = 'image/x-icon';
  faviconIcoLink.href = `${basePath}${theme.faviconIco}`;
  document.head.appendChild(faviconIcoLink);

  // Update manifest.json icon reference if it exists
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    // Note: manifest.json is static, but we can update the theme-color meta tag
    let themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (!themeColorMeta) {
      themeColorMeta = document.createElement('meta');
      themeColorMeta.name = 'theme-color';
      document.head.appendChild(themeColorMeta);
    }
    themeColorMeta.content = theme.primaryColor;
  }
};

/**
 * Initialize theme by setting CSS custom properties and updating favicon
 * This allows runtime theme switching via CSS variables
 */
export const initTheme = () => {
  // Set CSS variables on document root
  document.documentElement.style.setProperty('--theme-primary-color', theme.primaryColor);
  
  // Update favicon based on theme
  updateFavicon();
  
  // You can add more theme variables here as needed
  // document.documentElement.style.setProperty('--theme-secondary-color', theme.secondaryColor);
};

// Auto-initialize on import (for immediate effect)
if (typeof document !== 'undefined') {
  initTheme();
}

export default initTheme;
